import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "fill"]


export default /*@__PURE__*/_defineComponent({
  __name: 'ProhibitSvg',
  props: {
  width: {
    type: [String, Number],
    default: 32,
  },
  height: {
    type: [String, Number],
    default: 32,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _mergeProps(_ctx.$attrs, {
    width: __props.width,
    height: __props.height,
    fill: __props.fill,
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }), [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm88,104a87.56,87.56,0,0,1-20.41,56.28L71.72,60.4A88,88,0,0,1,216,128ZM40,128A87.56,87.56,0,0,1,60.41,71.72L184.28,195.6A88,88,0,0,1,40,128Z" }, null, -1)
  ]))], 16, _hoisted_1))
}
}

})